import React from 'react';
import PropTypes from 'prop-types';

import CreditStatusModal from '../CreditStatusModal';
import CreditBreakdownModal from '../CreditBreakdownModal';

const PERMITTED_ACTIONS = [
  'no_action',
  'dismiss',
  'invite_friends',
  'credit_details',
  'details',
  'login',
  'contact_support',
];

export default class CreditRedemptionModal extends React.Component {
  constructor(props) {
    super(props);

    this.openLinkHandler = this.openLinkHandler.bind(this);
    this.dismissModalHandler = this.dismissModalHandler.bind(this);
    this.inviteFriendsHandler = this.inviteFriendsHandler.bind(this);
    this.showBreakdownModalHandler = this.showBreakdownModalHandler.bind(this);

    this.state = {
      isDisplayed: true,
      view: 'status',
    };
  }

  getButtonAction(button) {
    switch (button.action) {
      case 'no_action':
      case 'dismiss': // legacy
        return { onClick: this.dismissModalHandler };
      case 'invite_friends':
        return { onClick: this.inviteFriendsHandler };
      case 'credit_details':
      case 'details': // legacy
        return { onClick: this.showBreakdownModalHandler };
      case 'login':
      case 'contact_support':
        return { href: button.action_url };
      default:
        // handle legacy API links, e.g.: input =>
        // { action: '/login', action_type: 'url' }
        // { action: '/support', action_type: 'url' }
        return { href: button.action };
    }
  }

  getActions(buttons) {
    const url = new RegExp('^/');
    return buttons
      .filter(
        (button) =>
          // filter out buttons not in the permitted actions list, or that aren’t a URL
          PERMITTED_ACTIONS.includes(button.action) || button.action.match(url),
      )
      .map((button) => ({
        ...button,
        ...this.getButtonAction(button),
      }));
  }

  openLinkHandler(url) {
    return () => (location.href = url); // eslint-disable-line no-return-assign
  }

  dismissModalHandler() {
    this.setState({ isDisplayed: false });
  }

  inviteFriendsHandler() {
    this.setState({ isDisplayed: false }, this.props.inviteFriendsHandler);
  }

  showBreakdownModalHandler() {
    this.setState({ view: 'breakdown' });
  }

  render() {
    const { appElement } = this.props;

    switch (this.state.view) {
      case 'status': {
        const { success, title, body, buttons } = this.props;

        return (
          <CreditStatusModal
            isDisplayed={this.state.isDisplayed}
            dismissModalHandler={this.dismissModalHandler}
            success={success}
            title={title}
            body={body}
            actions={this.getActions(buttons)}
            appElement={appElement}
          />
        );
      }
      case 'breakdown': {
        const { details, breakdownButtons } = this.props;

        return (
          <CreditBreakdownModal
            isDisplayed={this.state.isDisplayed}
            dismissModalHandler={this.dismissModalHandler}
            details={details}
            actions={this.getActions(breakdownButtons)}
            appElement={appElement}
          />
        );
      }
      default: {
        throw new Error(`Unknown view '${this.state.view}' for CreditRedemptionModal`);
      }
    }
  }
}

CreditRedemptionModal.propTypes = {
  success: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      level: PropTypes.oneOf(['primary', 'secondary']).isRequired,
      action_type: PropTypes.oneOf(['url', 'custom']),
      action: PropTypes.string,
      action_url: PropTypes.string,
    }),
  ).isRequired,
  breakdownButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      level: PropTypes.oneOf(['primary', 'secondary']).isRequired,
      action_type: PropTypes.oneOf(['url', 'custom']),
      action: PropTypes.string,
      action_url: PropTypes.string,
    }),
  ),
  details: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['header', 'table', 'list']).isRequired,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      heading: PropTypes.string,
      items: PropTypes.oneOfType([
        PropTypes.arrayOf(
          PropTypes.shape({
            key: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }).isRequired,
        ),
        PropTypes.arrayOf(PropTypes.string),
      ]),
    }).isRequired,
  ),
  inviteFriendsHandler: PropTypes.func.isRequired,
  appElement: PropTypes.string,
};

CreditRedemptionModal.defaultProps = {
  details: [],
  breakdownButtons: [],
  appElement: '#__next',
};
